var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isReady
    ? _c(
        "div",
        { staticClass: "project-time" },
        [
          _c(
            "portal-filter-bar",
            { attrs: { label: _vm.$t("global.filter") } },
            [
              _c("portal-search-field", {
                attrs: {
                  label: _vm.$t("global.filter"),
                  placeholder: _vm.$t("global.filter"),
                  "clear-label": _vm.$t("global.clear")
                },
                model: {
                  value: _vm.filter,
                  callback: function($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter"
                }
              }),
              _c("portal-select-field", {
                attrs: {
                  label: _vm.$t("global.date"),
                  options: _vm.dateOptions
                },
                on: { change: _vm.loadTimerEvents },
                model: {
                  value: _vm.dateFilter,
                  callback: function($$v) {
                    _vm.dateFilter = $$v
                  },
                  expression: "dateFilter"
                }
              })
            ],
            1
          ),
          _c("section", { staticClass: "project-time-summary" }, [
            _c("div", { staticClass: "summary-card" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("timetrack.reports.total-time")))
              ]),
              _c("strong", [
                _vm._v(
                  _vm._s(_vm.$formatters.formatSeconds(_vm.metrics.totalTime))
                )
              ])
            ]),
            _c("div", { staticClass: "summary-card" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("timetrack.reports.avg-month")))
              ]),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.$formatters.formatSeconds(_vm.metrics.averageMonthTime)
                  )
                )
              ])
            ]),
            _c("div", { staticClass: "summary-card" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("timetrack.reports.avg-week")))
              ]),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.$formatters.formatSeconds(_vm.metrics.averageWeekTime)
                  )
                )
              ])
            ])
          ]),
          _c("timer-event-table", {
            staticClass: "project-time-records",
            attrs: {
              "timer-events": _vm.projectTimerEvents,
              filter: _vm.filter,
              "hide-project": ""
            }
          })
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "project-time-loading" },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: 34, width: 3, color: "primary" }
          })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }